// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 * Escape a csv string
 * @param {string} str
 * @returns {string}
 */
export const escapeCsvString = str => `"${str.toString().replace(/"/g, '""')}"`

export const stripCommaCSV = str => `"${str.toString().replace(/,/g, '')}"`

/**
 * Use this if you have a value that could be interpreted numerically but
 * you want it to be interpreted as a string. For example, a tax number or
 * phone number.
 * @param {string} str
 * @returns {string}
 */
export const escapeExcelString = str => {
  const realStr = str.toString()

  return realStr.trim() ? '"="' + escapeCsvString(str) + '""' : '""'
}



// WEBPACK FOOTER //
// ./src/shared/csv.js